<template>
  <div class="box11">
    <pageTitle title="常见问题" text />

    <commomProblem
      class="box"
      :problemData="problemData"
      :styleData="styleData"
    />
    <div class="btn" @click="zixun('了解更多')">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "听说Java都饱和了，我还有必要学习么?",
          answer: [
            "1. Java的应用无处不在，从桌面办公应用到网络数据库，从PC到嵌入式移动平台，从Java小应用程序（Applet）到架构庞大的JavaEE企业级解决方案，处处都有Java的身影。从银行、证劵等金融行业到某里、某东等电商行业，从移动、电信为代表的通信行业到电、水、能源等公共服务行业，无一不是使用了Java来开发控制系统和相关软件。",
            "2. 用途如此之广的Java造就了Java工程师的需求！而在互联网+时代，社会需要大量的Java开发人员，Java程序员远未达到饱和，只是缺少合格和优秀的Java人才。",
          ],
        },
        {
          title: "你们上课模式是什么样子的？",
          answer: [
            "课程采用录播+直播的模式进行授课。录播学习——根据自己的基础和接受程度随时调整学习进度，学习更高效；直播答疑，所有疑问通通消灭。",
          ],
        },
        {
          title: "都学哪些项目?",
          answer: [
            "课程包含多个真实企业级实战项目，学完直接上手应对企业具体问题。具体项目详情请咨询老师。",
          ],
        },
        {
          title: "学完后达到什么样的水平?",
          answer: [
            "本课程采用案例+项目进行实战教学，学完可直接胜任Java工程师职位。当然，师傅领进门，修行靠个人，只有持续学习才能获取更好的职业发展机会。",
          ],
        },
        {
          title: "就业班和自己看视频有什么区别?",
          answer: [
            "1. 老师会给每一个学员制定专属的学习计划，课后有技术老师答疑解惑，高效学习的基础上缩短学习周期；",
            "2. 每周都有单元测试题、周测试题、阶段作业题，案例和项目练习等，能保证很好的学习效果；",
            "3. 给每一个学员360°的就业服务保障，帮助学员能高薪就业。",
          ],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/java/box11/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
       this.mai("JavaEE-就业课","了解更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box11 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/java/box11/bgc.png") no-repeat;
  background-size: cover;
  .box {
    margin-top: 48px;
  }
  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    line-height: 96px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
